export function getYandexUserId(cookieService): string {
  return cookieService.get('_ym_uid') || null;
}
